export type SummonerSpellEntry = { id: number; key: string; nameEn: string; nameRu: string };

export const SUMMONER_SPELLS: SummonerSpellEntry[] = [
  { id: 1, key: "SummonerBoost", nameEn: "Cleanse", nameRu: "Очищение" },
  { id: 3, key: "SummonerExhaust", nameEn: "Exhaust", nameRu: "Истощение" },
  { id: 4, key: "SummonerFlash", nameEn: "Flash", nameRu: "Вспышка" },
  { id: 6, key: "SummonerHaste", nameEn: "Ghost", nameRu: "Призрак" },
  { id: 7, key: "SummonerHeal", nameEn: "Heal", nameRu: "Лечение" },
  { id: 11, key: "SummonerSmite", nameEn: "Smite", nameRu: "Кара" },
  { id: 12, key: "SummonerTeleport", nameEn: "Teleport", nameRu: "Телепорт" },
  { id: 13, key: "SummonerMana", nameEn: "Clarity", nameRu: "Ясность" },
  { id: 14, key: "SummonerDot", nameEn: "Ignite", nameRu: "Воспламенение" },
  { id: 21, key: "SummonerBarrier", nameEn: "Barrier", nameRu: "Барьер" },
];

export function getSummonerSpellEntry(id: number): SummonerSpellEntry | undefined {
  return SUMMONER_SPELLS.find((s) => s.id === id);
}

export function getSummonerSpellName(id: number, locale: string): string {
  const s = getSummonerSpellEntry(id);
  if (!s) return String(id);
  return locale.startsWith("ru") ? s.nameRu : s.nameEn;
}

export function getSummonerSpellImageKey(key: string): string {
  return key.replace(/^Summoner/, "");
}
